import { SiteRoute } from '@journeyapps/package-types';
import { DocsNavigationNode } from '@journeyapps/package-docs';

export const getDocsNodePath = (item: DocsNavigationNode): string => {
  if (item.to) {
    return item.to;
  }

  for (const child of item.children ?? []) {
    const path = getDocsNodePath(child);
    if (path) {
      return path;
    }
  }

  return SiteRoute.DOCS;
};
